import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    ref: "chemComposer",
    style: { "width": "100%", "height": "400px" },
    class: "mt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        onOnUserArgChanged: _ctx.onUserArgChanged,
        onOnPopupDone: _ctx.onPopupDone,
        modalWidth: "xl",
        isActionBtnEnabled: _ctx.isActionBtnEnabled
    }, {
        afterForm: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, null, 512),
            (_ctx.testEditing)
                ? (_openBlock(), _createBlock(_component_FormWrapper, {
                    key: 0,
                    class: "mt-2",
                    id: "draw-smiles-wrapper"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_FormInput, {
                            modelValue: _ctx.currentSmiles,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.currentSmiles) = $event)),
                            placeHolder: "SMILES...",
                            id: "draw-smiles",
                            delayBetweenChangesDetected: 500,
                            validateDescription: false,
                            onOnChange: _ctx.onUpdateSMILES
                        }, null, 8, ["modelValue", "onOnChange"])
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnUserArgChanged", "onOnPopupDone", "isActionBtnEnabled"]));
}
